import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSection = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#232729",
		d: "M6 4a4 4 0 0 1 3.876 4.99l3.48 2.01 5.282-3.049a3 3 0 0 1 4.097 1.098l-6.379 3.682 6.38 3.684a3 3 0 0 1-4.098 1.098l-5.282-3.05-3.398 1.962q.041.282.042.575a4 4 0 1 1-1.555-3.165l1.912-1.104-2.277-1.315A4 4 0 1 1 6 4m0 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
	})]
});
export default SvgSection;
